import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'
import TypeUtils from '../lib/TypeUtils'
const { displayName, can, url } = TypeUtils

export default class TypeHeader extends Component {
  static propTypes = {
    type: PropTypes.object.isRequired
  }

  static contextTypes = {
    site: PropTypes.object
  }

  canEdit () {
    const {type} = this.props
    const {site} = this.context

    return can(site, type, 'update')
  }

  canAdd () {
    const {type} = this.props
    const {site} = this.context

    if (type.collection === false) return false

    return can(site, type, 'create') || can(site, type, 'create', type.id)
  }

  render () {
    const {type} = this.props
    const {site} = this.context
    const title = displayName(type)
    const base = url(site, type)

    return <div className='types-header'>
      <h1>{title}</h1>
      {this.canEdit() && <Link to={`${base}/edit`} className='btn'>Edit Model</Link>}
      {this.canAdd() && <Link to={`${base}/new`} className='btn'>Add New</Link>}
    </div>
  }
}



// WEBPACK FOOTER //
// ./app/components/TypeHeader.js